import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { SyncronizationService } from './../../core/services/synchronization.service';

@Component({
    selector: 'biz-viewer-entries-reload',
    template: `
        <div class="vw-entries-reload-container" *ngIf="isVisible">
            <i class="bz-icon bz-icon-bz-refresh" (click)="reloadEntries()"></i>
        </div>
    `,
    styles: [`
        .vw-entries-reload-container {
            height: 100%;
            display: flex;
            align-items: center;
        }
        
        .vw-entries-reload-container i {
            color: white;
            font-size: 20px;
            cursor: pointer
        }
    `]

})
export class ViewerEntriesReloadComponent implements OnInit {
    isVisible = false;
    private subscription: any;

    constructor(
        private _syncronization: SyncronizationService,
        private _store: Store<IStateViewer>
    ) { }

    ngOnInit() {
        this.subscription = this._store.select((s) => s.active)
            .subscribe((data: string) => {
                this.isVisible = data === 'Viewer';
            });
    }

    reloadEntries() {
        this._syncronization.EventReloadContent.next(true);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
